import { DateTimePicker, DateTimePickerOptions } from "@interface48/form-controls";
import React from "react";
import { processValue } from "../utils";
import { WidgetProps } from "./models";

interface DateWidgetProps extends WidgetProps<string> {
  options: {
    validStartDate?: string;
    validEndDate?: string;
  };
}

export const DateWidgetComponent = (props: DateWidgetProps) => {
  const { id, schema, required, value, onChange } = props;
  const { validStartDate, validEndDate } = props.options;

  let options: DateTimePickerOptions | undefined;

  // If it looks like options have been specified...
  if (validStartDate || validEndDate) {
    // If options are incomplete...
    if (!(validStartDate && validEndDate)) {
      throw Error("Both validStartDate and validEndDate must be specified.");
    }

    options = {
      validStartDate: validStartDate,
      validEndDate: validEndDate,
    };
  }

  const processDateValue = (value: string | undefined | null) => {
    return processValue(value, schema.type, required) as string | null | undefined;
  };

  return (
    <DateTimePicker
      id={id}
      label={schema.title}
      value={value}
      valueFormat={{ time: false }}
      processValue={processDateValue}
      onChange={onChange}
      options={options}
    />
  );
};

export const DateWidget = DateWidgetComponent;
